import type { AnyDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import { MetaItemType } from "../../../../../../../../api/types/svTypes.ts";

export const isReferenceDateField = (meta: AnyDescriptor) => {
  if (meta.itemType === MetaItemType.DIMENSION) {
    return meta.options?.asDateReference === true;
  }

  return false;
};
